import { SurveyIndexTable } from '@account/services/tables/survey-table/survey-index.table';
import { Component } from '@angular/core';
import { IndexView } from '@common/views/index/index.view';
import { Survey } from '@models/performance/survey.model';

@Component({
    templateUrl: './survey-index.template.html',
    styleUrls: ['./survey-index.style.scss'],
})
export class SurveyIndexView extends IndexView {
    createPermission = Survey.permission.edit;

    constructor(public table: SurveyIndexTable) {
        super();
        this.table.reload();
    }

    onCreate(): void {}
}
